import * as React from "react"

const Gauge = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 233.73 136.43"
    {...props}
  >
    <defs>
      <linearGradient
        id="gradient10"
        x1={27.32}
        y1={601.03}
        x2={152.84}
        y2={642.27}
        gradientTransform="translate(.01 -561.01)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#eaf3b9" />
        <stop offset={0.51} stopColor="#b9d816" />
        <stop offset={1} stopColor="#4ead90" />
      </linearGradient>
    </defs>
    <title>{"home-3-gauge-5"}</title>
    <path
      d="M197.5 99.75h-43.66a55.09 55.09 0 0 0-110.17-1.59v1.59H0a98.75 98.75 0 0 1 197.49-2c.02.68.02 1.34.01 2Z"
      fill="url(#gradient10)"
    />
    <path
      d="M98.76 133.06a30.09 30.09 0 1 1-1.1-60.17h1.1c8.86 0 99.39 24.08 109.69 26.83l12.2 3.25-12.2 3.26c-10.3 2.77-100.83 26.83-109.69 26.83Z"
      fill="#3e4c5e"
    />
    <path
      d="M98.75 76.26c8.69 0 108.83 26.71 108.83 26.71s-100.14 26.72-108.83 26.72a26.72 26.72 0 0 1 0-53.43m0-6.74a33.46 33.46 0 0 0 0 66.91c8.88 0 86.87-20.62 110.57-26.94l24.41-6.49-24.41-6.51c-23.7-6.32-101.69-26.94-110.57-26.94Z"
      fill="#fff"
    />
  </svg>
)

export default Gauge
